<template>
	<g>
		<defs>
		<path
			id="customers-a"
			class="cls-1" d="M14.4878559,12.8360167c1.2732058-.8208599,2.120142-2.2485037,2.120142-3.8726187,0-2.5406685-2.0673294-4.6079984-4.6079979-4.6079984s-4.6079984,2.0673294-4.6079984,4.6079984c0,1.624115.8469367,3.0517588,2.1201425,3.8726177-2.9145012.910387-5.0121441,3.3642578-5.0121441,6.2493877,0,.3087807.2504144.5591965.5591955.5591965h13.881608c.3087807,0,.5591965-.2504139.5591965-.5591965,0-2.8851299-2.0976429-5.3390007-5.0121441-6.2493868ZM8.5103931,8.963398c0-1.9242353,1.5653715-3.4896069,3.4896069-3.4896069s3.4896069,1.5653715,3.4896069,3.4896069-1.5653715,3.4896069-3.4896069,3.4896069-3.4896069-1.5653715-3.4896069-3.4896069ZM5.6507759,18.5262089c.3253503-2.778656,3.0486517-4.954813,6.3492241-4.954813s6.0238743,2.176156,6.3492241,4.954813H5.6507759Z"
		/>
		</defs>
		<g fill="none" fill-rule="evenodd">
		<rect
			width="24"
			height="24"
			fill="#E3E3E3"
			fill-opacity=".01"
			style="mix-blend-mode:color-burn"
		/>
		<use :fill="currentColor" :opacity="opacity" fill-rule="nonzero" xlink:href="#customers-a" />
		</g>
	</g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>